<template>
  <div class="collapse">
    <button @click="visible = !visible">
      <slot v-if="$slots.header" name="header" />

      <template v-else>
        <h4 v-html="title" />

        <icon :name="visible ? 'expand_less' : 'expand_more'" />
      </template>
    </button>

    <div v-show="visible" class="content">
      <slot />
    </div>
  </div>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    title: String,
  },

  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.collapse {
  + .collapse {
    margin-top: $gp;
  }
}

button {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0;
  width: 100%;
  background-color: transparent;
  border: none;
  color: inherit;
  text-align: left;
  cursor: pointer;

  &:hover {
    h4 {
      text-decoration: underline;
    }
  }

  h4 {
    font-family: $font-family;
    font-weight: normal;
    text-transform: none;
    margin-bottom: 0;
    margin-right: $gp;
  }
}

.content {
  padding-top: $gp;
}
</style>
